
export default {
  components: {
    Dialog: () => import('primevue/dialog'),
    Button: () => import('primevue/button')
  },
  props: {
    display: { type: Boolean, default: false },
    title: { type: String, default: '' },
    text: { type: String, default: '' }
  },
  computed: {
    localDisplay: {
      get() {
        return this.display
      },
      set(value) {
        this.$emit('update:display', value)
      }
    }
  },
  methods: {
    hideModal() {
      this.localDisplay = false
    }
  }
}
